import { withForm } from "@/components/ui/forms/hooks/useFormHook"
import { Separator } from "@/components/ui/baseUi/separator"
import { Text } from "@/components/ui/baseUi/text"
import { coachOfferFormDefaultValues } from "@/modules/coachOffers/types/coachOfferFormTypes"
import { EyeIcon } from "@images/svgIcons/eyeIcon"
import { LockOutlinedIcon } from "@images/svgIcons/lockOutlinedIcon"
import { CoachOfferCategoriesInput } from "@modules/coachOffers/components/coachOfferCategoriesInput"
import { CoachOfferRulesInput } from "@modules/coachOffers/components/coachOfferRulesInput"
import { word } from "@modules/core/utils/i18n"

export const CoachOfferStep3View = withForm({
  defaultValues: coachOfferFormDefaultValues,
  render: function CoachOfferStep3ViewInner({ form }) {
    return (
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <LockOutlinedIcon color="currentColor" className="size-5" />
            <Text fontStyle="TM">{word("coach.offers.form.infos.restrictedAccess.title")}</Text>
          </div>
          <Text fontStyle="BM" className="text-textOnSurface-subtle">
            {word("coach.offers.form.infos.restrictedAccess.subtitle")}
          </Text>
        </div>

        <form.AppField name="rules">
          {(field) => (
            <field.Field>
              <field.Label className="uppercase">{word("coach.offers.form.infos.restrictedPeriod.title")}</field.Label>
              <field.Content>
                <field.Description className="m-0! text-textOnSurface-subtle">
                  {word("coach.offers.form.infos.restrictedPeriod.subtitle")}
                </field.Description>
                <CoachOfferRulesInput
                  rules={field.state.value}
                  onChangeRules={(updatedRules) => {
                    field.handleChange(updatedRules)
                  }}
                />
              </field.Content>
            </field.Field>
          )}
        </form.AppField>

        <Separator />

        <form.AppField name="categoryIds">
          {(field) => (
            <field.Field>
              <field.Label className="uppercase">{word("coach.offers.form.infos.categories.title")}</field.Label>
              <field.Content>
                <field.Description className="m-0! text-textOnSurface-subtle">
                  {word("coach.offers.form.infos.categories.subtitle")}
                </field.Description>
                <CoachOfferCategoriesInput
                  selectedIds={field.state.value}
                  onChangeCategories={(ids) => {
                    field.handleChange(ids)
                  }}
                />
              </field.Content>
            </field.Field>
          )}
        </form.AppField>

        <Separator />

        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <EyeIcon color="currentColor" className="size-5" />
            <Text fontStyle="TM">{word("coach.offers.form.infos.visibility.title")}</Text>
          </div>
          <Text fontStyle="BM" className="text-textOnSurface-muted">
            {word("coach.offers.form.infos.visibility.subtitle")}
          </Text>
        </div>

        <form.AppField
          name="showcaseDisplay"
          listeners={{
            onChange: ({ value }) => {
              if (!value) form.setFieldValue("priceDisplay", false)
            },
          }}
        >
          {(field) => (
            <field.Field>
              <field.Label className="uppercase">{word("coach.offers.form.infos.showcaseDisplay.title")}</field.Label>
              <field.Content>
                <field.SwitchInline textSwitch={word("coach.offers.form.infos.showcaseDisplay.textSwitch")} />
                <field.Description className="m-0! text-center text-textOnSurface-subtle">
                  {word("coach.offers.form.infos.showcaseDisplay.description")}
                </field.Description>
              </field.Content>
            </field.Field>
          )}
        </form.AppField>

        <form.AppField name="priceDisplay">
          {(field) => (
            <field.Field>
              <field.Label className="uppercase">{word("coach.offers.form.infos.priceDisplay.title")}</field.Label>
              <field.Content>
                <form.Subscribe selector={(state) => state.values.showcaseDisplay}>
                  {(showcaseDisplay) => (
                    <field.SwitchInline
                      textSwitch={word("coach.offers.form.infos.priceDisplay.textSwitch")}
                      switchProps={{ disabled: !showcaseDisplay }}
                    />
                  )}
                </form.Subscribe>
                <field.Description className="m-0! text-center text-textOnSurface-subtle">
                  {word("coach.offers.form.infos.priceDisplay.description")}
                </field.Description>
              </field.Content>
            </field.Field>
          )}
        </form.AppField>

        <Separator />

        <form.AppField name="defaultHideSessionContent">
          {(field) => (
            <field.Field>
              <field.Label className="uppercase">
                {word("coach.offers.form.infos.sessionContentDisplay.title")}
              </field.Label>
              <field.Content>
                <field.SwitchInline textSwitch={word("coach.offers.form.infos.sessionContentDisplay.textSwitch")} />
                <field.Description className="px-5 text-center text-textOnSurface-subtle">
                  {word("coach.offers.form.infos.sessionContentDisplay.description")}
                </field.Description>
              </field.Content>
            </field.Field>
          )}
        </form.AppField>
      </div>
    )
  },
})
